import { render, staticRenderFns } from "./RemoveUserFromBUModal.vue?vue&type=template&id=7f752426&scoped=true&"
import script from "./RemoveUserFromBUModal.vue?vue&type=script&lang=js&"
export * from "./RemoveUserFromBUModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUserFromBUModal.vue?vue&type=style&index=0&id=7f752426&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f752426",
  null
  
)

export default component.exports